import type { AudioFileResponse } from "@/resources/audio";
import type { DialogWithRelations } from "@/resources/dialog";
import type { TranscriptResponse } from "@/resources/transcript";
import type { Filter } from "@/utils/apiFilter";
import { apiClient } from "./apiClient";

class DialogService {
  async list(filter: Filter = {}): Promise<DialogWithRelations[]> {
    try {
      const response = await apiClient.get<DialogWithRelations[]>("/dialogs", {
        ...filter,
        limit: 10000,
      });
      if (response.status === "OK" && response.result) {
        return response.result;
      }
      return [];
    } catch (error) {
      console.error("Failed to list results:", error);
      return [];
    }
  }

  async getById(dialogId: string): Promise<DialogWithRelations | null> {
    try {
      const response = await apiClient.get<DialogWithRelations>(
        `/dialogs/${dialogId}`,
      );
      if (response.status === "OK" && response.result) {
        return response.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to get result by ID:", error);
      return null;
    }
  }
  // TODO: Implement in conversation analysis page (requires backend fixes)
  async getDialogAudioById(
    dialogId: string,
  ): Promise<AudioFileResponse | null> {
    try {
      const response = await apiClient.get<AudioFileResponse>(
        `/dialogs/${dialogId}/audio`,
      );
      if (response.status === "OK" && response.result) {
        return response.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to get result audio by ID:", error);
      return null;
    }
  }

  async getTranscriptById(
    dialogId: string,
  ): Promise<TranscriptResponse | null> {
    try {
      const response = await apiClient.get<TranscriptResponse>(
        `/dialogs/${dialogId}/transcript`,
      );
      if (response.status === "OK" && response.result) {
        return response.result;
      }
      return null;
    } catch (error) {
      console.error("Failed to get dialog transcript by ID:", error);
      return null;
    }
  }
}
export const dialogService = new DialogService();
